@if (isOpen()) {
  <div class="modal-backdrop" (click)="onBackdropClick($event)" role="dialog" aria-modal="true" [attr.aria-labelledby]="title ? 'modal-title' : null">
    <div class="modal-container" [style.max-width]="maxWidth">
      @if (showHeader) {
        <div class="modal-header">
          @if (title) {
            <h2 id="modal-title" class="modal-title">{{ title }}</h2>
          }
          <button type="button" class="modal-close-btn" (click)="close()" aria-label="Close modal">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>
      }
      <div class="modal-body" [style.padding]="bodyPadding">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
